<template>
    <button @click.prevent="handleWatchDogPopup" class="button watch-dog">
        Preveriť dostupnosť
    </button>
</template>

<script>
import emitter from '../../utils/emitter'

export default {

    setup() {

        function handleWatchDogPopup() {
            emitter.emit('showWatchDogPopup')
        }

        return {
            handleWatchDogPopup
        }
    }
}
</script>
